import type { FC } from 'react'

import { AboutUsPage } from 'components'

const AboutUs: FC = () => <AboutUsPage />

export default AboutUs
